const Projects =()=>{
return (<section className="project-section py-3">
<h3 className="text-uppercase resume-section-heading mb-4">
    Projects
</h3>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Roshambo (Rock, Paper, Scissors, Lizard, Spock)
        </h4>
    </div>
    <div className="item-content">
        <p>
           Want to play an easy to play game? Built with React.JS, Next.JS and Bootstrap, the game gets interesting
           especially when competing with friends online. The project is hosted at:{" "}
            <a href="https://roshambo.karimkkanji.com">
                https://roshambo.karimkkanji.com/
            </a>
        </p>
    </div>
</div>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Budgeteer
        </h4>
    </div>
    <div className="item-content">
        <p>
            Budgeteer is a React.JS application built to help people
            budget their incomes with recommended proportions to help
            them manage their finances better. The project is hosted at:{" "}
            <a href="https://budgeteer.karimkkanji.com">
                https://budgeteer.karimkkanji.com/
            </a>
        </p>
    </div>
</div>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Notes by Cryosoft
        </h4>
    </div>
    <div className="item-content">
        <p>
            Notes by Cryosoft is a web app that allows people to share realtime notes, that can be locked to prevent
            editing, allows saving notes to profile and allows for automatic saving of notes. The project is hosted at:{" "}
            <a href="https://notes.cryosoft.co.ke/">
                https://notes.cryosoft.co.ke/
            </a>. The Web app is a Progressive Web App, allowing one to easily install it as an app on Windows and Android via Google Chrome or Microsoft Edge.
        </p>
    </div>
</div>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Github Profiles on Demand
        </h4>
    </div>
    <div className="item-content">
        <p>
            Get your Github profile and that of others quickly. This
            project is built using React.js and TypeScript. The Web
            Application is hosted at{" "}                        <a href="https://github-on-demand.cryosoft.co.ke/">
                https://github-on-demand.cryosoft.co.ke/
            </a>
        </p>
    </div>
</div>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            QR code Generator - Version 2
        </h4>
    </div>
    <div className="item-content">
        <p>
            Generate Beautiful QR codes that you can download and share.
            This project is built using React.js and TypeScript. The Web
            Application is hosted at{" "}<a href="https://qr-generator.cryosoft.co.ke/">
                https://qr-generator.cryosoft.co.ke/
            </a>
        </p>
    </div>
</div>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            QR code Generator - Version 1
        </h4>
    </div>
    <div className="item-content">
        <p>
            Easily and Quickly generate Basic QR codes that you can download and share.
            The Web Application is hosted at{" "}<a href="https://qr.cryosoft.co.ke/">
                https://qr.cryosoft.co.ke/
            </a>
        </p>
    </div>
</div>
<div className="item mb-3">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Protection (Maseno Edition)
        </h4>
    </div>
    <div className="item-content">
        <p>
            This is a pilot project done in 2020 that was tested in
            Maseno Town around Maseno University to provide a delivery
            service of condoms through a web app and an android
            application that has been developed to ease the ordering and
            delivery process.This is to achieve one of the SDGs: Ensure
            healthy lives and promote wellbeing for all at all ages, by
            reducing the infections of HIV and STIs in Maseno. The
            application only uses the phone number and location of the
            users to achieve a successful delivery. The application can
            be found at{" "}
            <a href="https://protection.cryosoft.co.ke">
                https://protection.cryosoft.co.ke
            </a>{" "}
            and the android application downloaded from{" "}
            <a href="https://protection.cryosoft.co.ke/app/">
                https://protection.cryosoft.co.ke/app/
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Masiri
        </h4>
    </div>
    <div className="item-content">
        <p>
            An online venting platform available as a web app, a
            Progressive Web App and as an android application. The
            application is available on play store. Link to app is{" "}
            <a href="https://kutt.it/masiri-app">
                https://kutt.it/masiri-app
            </a>{" "}
            and the Web Application is hosted at{" "}
            <a href="https://masiri.cryosoft.co.ke">
                https://masiri.cryosoft.co.ke
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Masiri telegram Bot
        </h4>
    </div>
    <div className="item-content">
        <p>
            A telegram Bot Created to upload user stories as well as
            display stories posted in Masiri. The bot can be accessed
            using the following link:
            <a href="https://t.me/masiri_kebot">
                https://t.me/masiri_kebot
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Betting Tips Ke
        </h4>
    </div>
    <div className="item-content">
        <p>
            An online website offering betting tips. The front end for
            the users and the admin panel. The application is hosted at{" "}
            <a href="https://bettingtipske.co.ke">
                https://bettingtipske.co.ke
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Kisumu Health Department Work plan
        </h4>
    </div>
    <div className="item-content">
        <p>
            An annual work plan that allows the department to track
            project progress using evidence presented and uploaded. The
            application can be installed via Google Chrome as a PWA. The
            application is currently hosted at{" "}                        <a href="https://workplan.keron.co.ke">
                https://workplan.keron.co.ke
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Kisumu Health Department Data Visualization Tool
        </h4>
    </div>
    <div className="item-content">
        <p>
            A tool to draw charts from DHIS2 and manually create charts
            created for Kisumu County Health Department. The application
            can be viewed at{" "}                        <a href="https://khd-datavisualiser.keron.co.ke">
                https://khd-datavisualiser.keron.co.ke
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            DHIS2 Metadata Dictionary{" "}
        </h4>
    </div>
    <div className="item-content">
        <p>
            A react app built to be used in DHIS2 to view and update
            metadata for DHIS2. Worked on in a team of 4. The
            application documentation can be found at{" "}                        <a href="https://metadatadhis2.readthedocs.io/en/latest/">
                https://metadatadhis2.readthedocs.io/en/latest/
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Covid-19 Kenyan Updates
        </h4>
    </div>
    <div className="item-content">
        <p>
            This project aims at creating information about the 2020
            Pandemic, the COVID-19 Cases in Kenya only and provide tips
            and latest news on the disease in Kenya. It is accessible
            at:{" "}
            <a href="https://covid19.cryosoft.co.ke">
                https://covid19.cryosoft.co.ke
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Devnews | Developer News Stand
        </h4>
    </div>
    <div className="item-content">
        <p>
            Read about developer news and what matters to you as a
            developer to keep you up to date only on DevNews. The site
            is available at{" "}                        <a href="https://devnews.cryosoft.co.ke">
                https://devnews.cryosoft.co.ke.
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Devnews | Developer News Stand [Android App]
        </h4>
    </div>
    <div className="item-content">
        <p>
            With a collection of daily updated articles, DevNews makes
            it easy to get news as a developer at your fingertips. With
            curated articles that are aggregated daily, we'll keep you
            up to date with what developers need to know and what will
            help you as a developer to keep in the know! The app is
            available at{" "}                        <a href="https://play.google.com/store/apps/details?id=ke.co.cryosoft.devnews">
                https://play.google.com/store/apps/details?id=ke.co.cryosoft.devnews
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Drive In Theory 2
        </h4>
    </div>
    <div className="item-content">
        <p>
            A web version and improvement to the Mobile App, Drive In
            Theory allowing all users to access resources more easily on
            all platforms to learn about Driving in Kenya and anywhere
            in the world that used the "Keep Left Rule" on the roads. It
            can be accessed at{" "}
            <a href="https://dit.cryosoft.co.ke">
                https://dit.cryosoft.co.ke
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Drive In Theory 2 [Android App]
        </h4>
    </div>
    <div className="item-content">
        <p>
            Drive In Theory was great. But want a better and improved
            app? Drive In Theory 2 is designed to aid Drivers and
            Students Learning how to Drive especially in countries where
            the "Keep left rule" applies to drivers. This app was
            developed for any driver, but more so anyone who wants to
            gain knowledge about driving and the road in general. We
            have designed the app in such a way that once you install
            the app, you will not need to UPDATE it because well do the
            updating in our own special way to allow you to access
            content that is up to date and is approved by NTSA since we
            source the information that is the app from NTSA. The app
            can be downloaded at{" "}                        <a href="https://play.google.com/store/apps/details?id=ke.co.cryosoft.dit">
                https://play.google.com/store/apps/details?id=ke.co.cryosoft.dit
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Drive In Theory [Mobile App]
        </h4>
    </div>
    <div className="item-content">
        <p>
            This app was developed for any driver, but more so anyone
            who wants to gain knowledge about driving and the road in
            general. This app contains multiple questions, notes that{" "}                        one can go through as well as learn about road signs. The
            app can be downloaded at{" "}                        <a href="https://play.google.com/store/apps/details?id=kkk.cryosoft.driveintheory">
                https://play.google.com/store/apps/details?id=kkk.cryosoft.driveintheory
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Is My Server/Websites Up? [Telegram Bot]
        </h4>
    </div>
    <div className="item-content">
        <p>
            A bot to help you easily check if your Website or Server is
            Up or Down. The bot can be used at{" "}
            <a href="https://t.me/site_is_up_bot">
                https://t.me/site_is_up_bot
            </a>
            ,
        </p>
    </div>
</div>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Is My Server/Websites Up? [Web App]
        </h4>
    </div>
    <div className="item-content">
        <p>
            A Web app that helps you easily check if your Website or Server is
            Up or Down. The Web App can be used at{" "}
            <a href="https://is-up.cryosoft.co.ke/">
                https://is-up.cryosoft.co.ke/
            </a>
            ,
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            WeinactionRJ
        </h4>
    </div>
    <div className="item-content">
        <p>
            WeinactionRJ is a community-based organization offering
            loans to its members. It can be accessed at{" "}
            <a href="https://weinactionrj.cryosoft.co.ke/">
                https://weinactionrj.cryosoft.co.ke/
            </a>
        </p>
    </div>
</div>
{/*//item*/}
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            The Word Heist Event Online Ticket Booking
        </h4>
    </div>
    <div className="item-content">
        <p>
            The Word Heist was an event planned to take place on March
            8, 2020 that aimed at poetry and spoken word sharing. The
            site allowed for booking and tracking of participants and
            allow them to see who is attending and more about the event.
            The website is available at{" "}                        <a href="https://thewordheist.cryosoft.co.ke/">
                https://thewordheist.cryosoft.co.ke/
            </a>
        </p>
    </div>
</div>
{/*//item*/}
{/* <div className="item">
<div className="item-heading row align-items-center mb-2">
<h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0" />
</div>
<div className="item-content">
<p></p>
</div>
</div> */}
{/*//item*/}
</section>);
}

export default Projects;